<template>
  <div class="page-container">
    <el-card>
      <app-form
        ref="app_form_ref"
        :form-data="form_config"
        default-label-width="100px"
        :submit-request="onSubmit"
        :is-show-button="false"
        :form-props="{ inline: true }"
      >
        <template #custom="{ form_key }">
          <div v-if="form_key === 'action'">
            <el-button type="primary" size="mini" @click="auth">授权</el-button>
          </div>
        </template>
      </app-form>
    </el-card>
  </div>
</template>

<script>
import { getMediasListApi } from '@/api/medias';
import { generateAuthUrlApi, authCallbackApi } from '@/api/media/auth';

export default {
  name: 'AuthManage',
  components: {
    'app-form': () => import('@/components/app-form'),
  },
  data() {
    return {
      /** 表单配置 */
      form_config: require('./model/form-config')(this),
      /** 授权广告账户存储key */
      auth_adv_ids_storage_key: 'auth_adv_ids_storage_key',
    };
  },
  created() {
    this.authCallback();

    const { channel_interface } = this.form_config;
    this.onChannelChange(channel_interface.value, false);
  },
  methods: {
    /**
     * 表单提交
     * @param {object} params 表单参数
     */
    onSubmit(params) {
      const { channel_interface, advertiser_ids } = params;
      localStorage.setItem(this.auth_adv_ids_storage_key, JSON.stringify(advertiser_ids));
      generateAuthUrlApi({ channel_interface }).then(({ url }) => {
        window.open(url, '_blank');
      });
    },
    /**
     * 确认授权
     * @returns {void}
     */
    auth() {
      this.$refs.app_form_ref.confirm();
    },
    /**
     * 监听媒体平台改变
     * @param {string} type 媒体平台标识
     */
    async onChannelChange(type, is_clear = true) {
      const params = { type, is_list: true };
      const { advertiser_ids } = this.form_config;
      const ret = await this.getAdvertiserList(params);
      is_clear && advertiser_ids.value.splice(0);
      advertiser_ids.options = ret;
    },
    /**
     * 获取广告主账号列表
     * @param {object} params 请求参数
     * @returns {Promise<object[]>}
     */
    getAdvertiserList(params) {
      return new Promise((resolve, reject) => {
        getMediasListApi(params).then((response) => {
          const result = response.list.map(({ advertiser_id, advertiser_name, note }) => {
            return {
              label: `${advertiser_id}（${advertiser_name}）${note ? ' - ' + note : ''}`,
              value: advertiser_id,
            };
          });
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 授权回调
     */
    authCallback() {
      const query = this.$route.query || {};
      const { state: channel_interface, user_status: status, user_token: token, expire_time } = query;
      const adv_ids_storage = localStorage.getItem(this.auth_adv_ids_storage_key);
      const is_valid = [channel_interface, status, token, adv_ids_storage].every(i => !!i);
      if (is_valid) {
        const adv_ids = JSON.parse(adv_ids_storage);
        const payload = {
          channel_interface,
          status,
          token,
          expire_time,
          advertiser_ids: adv_ids,
        };

        const { advertiser_ids } = this.form_config;
        advertiser_ids.value = adv_ids;

        authCallbackApi(payload).then(({ message }) => {
          this.$message.success(message || '授权成功');
        }).finally(() => {
          localStorage.removeItem(this.auth_adv_ids_storage_key);
        });
      }
    },
  },
};
</script>
